import React from "react";
import { StaticQuery, graphql, Link } from "gatsby";

export default () => (
  <StaticQuery
    query={graphql`
      {
        chicagoJobs: allLever(
          limit: 100
          filter: { categories: { location: { eq: "Chicago, Illinois" } } }
        ) {
          edges {
            node {
              text
              id
              lever_id
              description
              additional
              categories {
                commitment
                department
                location
                team
              }
              lists {
                text
                content
              }
              hostedUrl
              applyUrl
            }
          }
        }
      }
    `}
    render={data => {
      const chicagoJobs = data.chicagoJobs.edges.map(chicagoJob => {
        return {
          jobTitle: chicagoJob.node.text,
          id: chicagoJob.node.id,
          leverId: chicagoJob.node.lever_id,
          description: chicagoJob.node.description,
          location: chicagoJob.node.categories.location
        };
      });

      const locations = Array.from(
        new Set(chicagoJobs.map(item => item.location))
      ).sort();

      return (
        <>
          {/* Begins looping through array of locations */}
          {locations.map(location => (
            // If you're going to output a list of things, you need a key
            <React.Fragment key={location}>
              <ul className="openings">
                {/* We're starting with a list of all the postings, not just the ones for this particular location, so we need to filter them */}
                {chicagoJobs
                  // Look in each posting
                  // Return only those where that posting's location matches the current location
                  // posting is the argument; posting.location === location is the return value, which is a boolean
                  .filter(chicagoJob => chicagoJob.location === location)
                  // Now our list is just from that one location, so we can use map to output our postings
                  // posting is the argument; the stuff b/w the parentheses produces a JSX element
                  // Again, needs a key because it's a list
                  .map(chicagoJob => (
                    <Link to={`/openings/posting/${chicagoJob.leverId}`}>
                      <li key={chicagoJob.leverId}>{chicagoJob.jobTitle}</li>
                    </Link>
                  ))}
              </ul>
            </React.Fragment>
          ))}
        </>
      );
    }}
  />
);
